
import { Card, CardContent } from "@/components/ui/card";

export function AuthProcessingState() {
  return (
    <Card className="w-full mb-4">
      <CardContent className="pt-6 text-center">
        <p>Processing authentication...</p>
      </CardContent>
    </Card>
  );
}
